import React, { useEffect, useState } from "react";
import { Popup } from "@t8891/mobile";
import { useSetState } from "ahooks";
import { BottomFillIcon } from "@t8891/icon";
import { InquirySecondInformation, InquirySecondInformationOption } from "@legacy/types/bidding";
import { ISuperFrom } from "@components/InquiryLogistics/SuperForm";
import { collectDefaultItems, getValueByItemId, getValueByItemIdCascader, mergeUnique } from "utils/InquiryLogistics";
import CascaderPopup from "@components/InquiryLogistics/CascaderPopup";
import MaskShade from "./Mask";

type TItem = InquirySecondInformation["form"]["fields"][0];

interface ICascader extends ISuperFrom {
  item: TItem;
  parentItemId: number;
}

const Cascader: React.FC<ICascader> = ({ item, formParams, onChange, parentItemId }) => {
  const { label, options, title, required, itemId, placeholder, defaultValue, type } = item;

  const [params, setParams] = useSetState({
    visible: false,
  });
  const { visible } = params;

  let labelAndValue = getValueByItemIdCascader({ formParams, itemId, item, parentItemId });

  useEffect(() => {
    if (formParams?.length) {
      const resultItems = collectDefaultItems([item]);

      let result = formParams.filter((item: any) => item.itemId === itemId);

      const mergedArray = mergeUnique(resultItems, result);
      if (mergedArray.length > 0) {
        mergedArray.forEach((item: any) => {
          item.parentItemId = parentItemId;
        });

        onChange(mergedArray, "defaultValue");
      }
    }
  }, []);
  let isChiildren = parentItemId === item.itemId;
  return (
    <div className={`${isChiildren ? "grid" : "flex"}  gap-12`}>
      <div className={`${isChiildren ? "text-16 font-[600]" : "text-14  h-40"} flex whitespace-pre items-center`}>
        {!!required && (
          <div className='flex items-center'>
            <div className='text-[#FF0000] text-16 h-10'>*</div>
          </div>
        )}
        {title}
      </div>
      <div
        style={{ border: "1px solid #E8E8E8" }}
        className={`${
          isChiildren ? "w-[446px] rounded-4" : "w-[300px]"
        } flex justify-between h-40 items-center  pl-16 pr-8 text-14 relative cursor-pointer`}
        onClick={() => {
          setParams({ visible: true });
        }}
      >
        <MaskShade
          visible={visible}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setParams({ visible: false });
          }}
        >
          <CascaderPopup
            visible={visible}
            item={item}
            parentItemId={parentItemId}
            formParams={formParams}
            onClose={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setParams({ visible: false });
            }}
            onChange={(e, items) => {
              e.stopPropagation();
              e.preventDefault();
              items.map((vv: any) => {
                vv.parentItemId = parentItemId;
                onChange(vv);
              });
              setParams({ visible: false });
            }}
          />
        </MaskShade>

        <div
          className={`ellipsis ${!!labelAndValue ? "text-[#333]" : "text-[#BBB]"}`}
          dangerouslySetInnerHTML={{ __html: labelAndValue || placeholder }}
        />
        <BottomFillIcon size={20} fill='#818181' />
      </div>
    </div>
  );
};

export default Cascader;
